import { render, staticRenderFns } from "./Error404View.vue?vue&type=template&id=b5c84938&"
import script from "./Error404View.vue?vue&type=script&lang=js&"
export * from "./Error404View.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports